import { motion } from "framer-motion";
import { Compass, FileSearch, ListChecks, ShieldAlert, GraduationCap, Sparkles } from "lucide-react";

const POINTS = [
  { icon: Compass, title: "Understanding the VA system", body: "We know how the VA process works — not just how it's supposed to work on paper." },
  { icon: Sparkles, title: "Legally maximize opportunities", body: "We help you identify every avenue available under VA policy and law." },
  { icon: FileSearch, title: "Organize documentation", body: "We help you prepare clean, well-organized records that strengthen your file." },
  { icon: ListChecks, title: "Identify qualifying conditions", body: "Many Veterans miss qualifying conditions they didn't realize they had." },
  { icon: ShieldAlert, title: "Avoid common mistakes", body: "Small mistakes derail claims. We help you sidestep the costly ones." },
  { icon: GraduationCap, title: "Step-by-step guidance", body: "You're never alone in the process. We walk you through every step." },
];

export default function Differentiation() {
  return (
    <section id="difference" className="section bg-[#F5F5F7]">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.6 }} className="max-w-3xl"
        >
          <p className="text-[11px] tracking-[0.22em] uppercase text-slate-500">Why we're different</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A1930] mt-3 leading-[1.05]">
            Many claim to help. Few actually do.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            We're not a marketing funnel. We're Veterans who understand the system —
            and we're here to help you maximize what you've already earned.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="bg-white border border-slate-200 rounded-3xl p-7 hover:-translate-y-0.5 hover:shadow-[0_20px_50px_-30px_rgba(10,25,48,0.35)] transition-all"
              data-testid={`diff-card-${i}`}
            >
              <div className="w-11 h-11 rounded-2xl bg-[#0A1930] text-white grid place-items-center">
                <p.icon className="w-5 h-5" strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-lg mt-5 text-[#0A1930]">{p.title}</h3>
              <p className="mt-2 text-[15px] text-slate-600 leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 text-xs text-slate-400 max-w-2xl">
          We are not attorneys and do not provide legal advice. We help Veterans understand
          and organize their claim opportunities under VA policy.
        </p>
      </div>
    </section>
  );
}
